import { Center, Flex, Highlight, Stack, Text, UnstyledButton } from "@mantine/core";
import type { JSX } from "react";
import { useState } from "react";
import { LightBulbIcon, RightArrowIcon } from "@/sales-tools/home-product/components/Icons";
import { wrapIndex } from "@/sales-tools/utils/wrapIndex";

export type ChecklistItemExample = { text: string; highlights?: string[] };

export function ChecklistItemExampleCarousel({ examples }: { examples: ChecklistItemExample[] }): JSX.Element | null {
    const [index, setIndex] = useState(0);
    const { text, highlights } = examples[index];

    return (
        <Stack gap={0}>
            <Flex align="center" justify="end">
                <UnstyledButton
                    pl="xxs"
                    pr="xxs"
                    size="compact-xs"
                    variant="transparent"
                    onClick={() => setIndex(wrapIndex(index - 1, examples.length))}
                    c="dark.2"
                >
                    <RightArrowIcon height="12" width="12" x="-1" />
                </UnstyledButton>

                <Text size="12px" ta="end">
                    {index + 1} of {examples.length}
                </Text>

                <UnstyledButton
                    pl="xxs"
                    pr="xxs"
                    size="compact-xs"
                    variant="transparent"
                    onClick={() => setIndex(wrapIndex(index + 1, examples.length))}
                    c="dark.2"
                >
                    <RightArrowIcon height="12" width="12" />
                </UnstyledButton>
            </Flex>
            <Flex p="xxs" bg="#333f4880">
                <Center p="0.25rem 0.5rem 0.5rem 0rem">
                    <LightBulbIcon />
                </Center>
                <Highlight
                    size="12px"
                    lh="sm"
                    highlightStyles={{
                        color: "#D0AAF1",
                        fontWeight: 700,
                        backgroundColor: "transparent",
                    }}
                    highlight={highlights ?? []}
                >
                    {text}
                </Highlight>
            </Flex>
        </Stack>
    );
}
